import Task from "../../../lib/html5-software-library/src/ranj/util/executor/Task";
import Config from "../core/config/Config";
import GoogleAnalyticsConfig from "./GoogleAnalyticsConfig";
import GoogleAnalyticsEvent from "./GoogleAnalyticsEvent";

export default class InitGoogleAnalyticsTask extends Task {

    /**
     * Task to load and initialize GoogleAnalytics
     * @param {soma.EventDispatcher} dispatcher - the soma EventDispatcher
     * @param {Config} config
     * @param {GoogleAnalyticsConfig} googleAnalyticsConfig
     */
    constructor(dispatcher, config, googleAnalyticsConfig) {
        super();
        this._dispatcher = dispatcher;
        this._config = config;
        this._googleAnalyticsConfig = googleAnalyticsConfig;
    }

    execute(callback) {
        try {
            // initialize config
            const analyticsJson = this._config.getValue("googleanalytics");
            this._googleAnalyticsConfig.setPropertiesFromObject(analyticsJson);

            // Load Google Analytics gtag.js
            // See: https://developers.google.com/analytics/devguides/collection/gtagjs
            const script = document.createElement("script");
            document.getElementsByTagName('body')[0].appendChild(script);
            script.onload = () => {
                window.dataLayer = window.dataLayer || [];
                window.gtag = function() { window.dataLayer.push(arguments); };
                window.gtag('js', new Date());
                //To enable GA cookies in an cross-origin iframe setup, we need to set the SameSite and Secure attributes
                //  (https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite)
                gtag('set', { cookie_flags: 'SameSite=None;Secure' });
                //start session
                this._dispatcher.dispatch(GoogleAnalyticsEvent.INIT);
                this._dispatcher.dispatch(GoogleAnalyticsEvent.SESSION_START);
            };
            const measurementId = this._googleAnalyticsConfig.trackingId;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
        } catch (err) {
            console.error(err);
        } finally {
            // Complete task even when GA is blocked
            callback(this);
        }
    }
}